/**
 * Design tokens for the orders screen.
 *
 * Colours come from the mobile app's orders module (lib/view/components/shared/
 * app_ui.dart) so both clients read the same; radii and control heights follow
 * this desktop app's existing panels.
 *
 * Nothing here is computed at runtime — import the token, never the literal.
 */
export const T = {
  // Surfaces
  canvas: '#F4F5F7',
  surface: '#FFFFFF',
  sunk: '#FAFAFB',
  hover: '#F5F6F8',
  border: '#E6E8EC',
  borderStrong: '#D8DCE2',
  hairline: '#F0F1F4',

  // Ink
  ink: '#15181D',
  inkSoft: '#6B7280',
  inkFaint: '#9AA1AC',
  inkGhost: '#C2C7CF',

  // Brand — invoice status and primary actions
  brand: '#F64829',
  brandInk: '#C3341A',
  brandTint: '#FFEBE6',
  selectedBg: '#FFF1ED',
  selectedBorder: '#F7C6B9',

  // Status
  paid: '#16A34A',
  paidTint: '#E9F7EF',
  pending: '#E1930B',
  pendingInk: '#B87409',
  pendingTint: '#FDF3E2',
  pendingBorder: '#E3C892',
  canceled: '#9AA1AC',
  canceledTint: '#F1F2F4',

  // Destructive
  danger: '#DC2626',
  dangerTint: '#FDECEC',
  dangerMuted: '#F2B4AE',
  dangerBorder: '#F3CFC8',
  /** Outlined-Cancel border. Weighted to sit level with pendingBorder so the
   *  two buttons beside each other read as peers, not one shouting. */
  dangerBorderStrong: '#F0B0AB',

  // Summary band
  header: '#04565E',
  onHeader: '#FFFFFF',
  onHeaderSoft: '#B4D2D6',
  onHeaderFaint: '#8FBFC4',
  headerBorder: 'rgba(255,255,255,0.14)',
  headerControlBorder: 'rgba(255,255,255,0.24)',
  headerCash: '#4ADE80',
  headerInvoice: '#5EEAD4',
  headerPending: '#FBBF24',
  headerDanger: '#FCA5A5',

  // Geometry
  radiusPanel: 10,
  radiusControl: 8,
  radiusSmall: 7,
  radiusPill: 999,
  rowHeight: 48,
  controlHeight: 34,
  panelWidth: 396,
  screenPadding: 20,

  // Elevation
  popover: '0 8px 24px rgba(21,24,29,0.08)',
  dialog: '0 12px 32px rgba(21,24,29,0.10)',
};

/**
 * One order row: status · Dalab # · waiter · items · date+time · discount ·
 * total · action. Header, rows and skeleton all use this track.
 */
export const ROW_COLUMNS =
  '88px 96px minmax(0,1fr) 76px 148px 72px 92px 84px';

/** Same, minus the waiter column — waiters only ever see their own orders. */
export const ROW_COLUMNS_SELF =
  '88px 96px 76px 148px 72px 92px 84px';

/** Gap between row cells. */
export const ROW_GAP = 12;

export const FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

/** Money and times line up in columns, so every figure uses lining figures. */
export const NUMERIC = { fontVariantNumeric: 'tabular-nums' };
